// Utils
import { isObjectV2 } from "Utils/global.js"
import {
  tag99Advisory,
  controlParametersAuthorizedModifManager,
  controlPropsMappingRiskCanBePatched,
} from "Utils/checkAccess.js"
import { getLocaleSuffix } from "Utils/translationLoader"

export const getFilterControlPlansNotArchived = listControlPlans => {
  const newList = [...listControlPlans]
  if (!Array.isArray(newList)) return []
  return newList.filter(controlPlan => !controlPlan.isArchived)
}

export const getControlReadyToPatch = (control, businessTag) => {
  const newControlToPatch = {}
  let propsCanBePatched = controlPropsMappingRiskCanBePatched
  if (businessTag === tag99Advisory) propsCanBePatched = controlParametersAuthorizedModifManager
  if (!isObjectV2(control) || !Array.isArray(propsCanBePatched)) return newControlToPatch
  Object.keys(control).forEach(props => {
    if (propsCanBePatched.includes(props)) {
      newControlToPatch[props] = control[props]
    }
  })
  return newControlToPatch
}

// TODO : Maybe we can regroup this functions
export const getNotifUsersAffectedToControl = (currentUser, trad, control) => {
  const localeSuffix = `_${getLocaleSuffix(currentUser?.LANGUAGE_ID)}`
  return {
    to_principals: control?.targetUsers?.usersIds?.map(id => {
      return `user:${id}`
    }),
    data: {
      event: `${trad?.ASSIGNATION_CONTROLE}`,
      elementInBold: control?.process,
      redirectUrl: `/controlPlans/${control?.controlPlanId}`,
      byUser: `${currentUser.FIRSTNAME} ${currentUser.LASTNAME}`,
      infos: ``,
      email: {
        url: "https://pocketstudio.pocketresult.com/",
        event: `${currentUser.FIRSTNAME} ${currentUser.LASTNAME} ${trad?.ASSIGNATION_CONTROLE}`,
      },
      redirect_state: { tabToUse: "validationControls" },
    },
    ephemeral: false,
    channel_id: "control_assignment" + localeSuffix,
  }
}

export const getNotifUsersAffectedToControlPlan = (currentUser, trad, controlPlan, newId) => {
  const localeSuffix = `_${getLocaleSuffix(currentUser?.LANGUAGE_ID)}`

  return {
    to_principals: controlPlan?.responsiblesIds?.map(id => {
      return `user:${id}`
    }),
    data: {
      event: `${trad?.ASSIGNATION_PLAN_CONTROLE}`,
      elementInBold: controlPlan?.name,
      redirectUrl: `/controlPlans/${newId}`,
      byUser: `${currentUser.FIRSTNAME} ${currentUser.LASTNAME}`,
      infos: ``,
      email: {
        url: "https://pocketstudio.pocketresult.com/",
        event: `${currentUser.FIRSTNAME} ${currentUser.LASTNAME} ${trad?.ASSIGNATION_PLAN_CONTROLE}`,
      },
      redirect_state: {},
    },
    ephemeral: false,
    channel_id: "control_assignment" + localeSuffix,
  }
}

export const getNotifPatchControlPlanAssign = (
  currentUser,
  trad,
  controlPlan,
  usersToInform,
  controlPlanId
) => {
  const localeSuffix = `_${getLocaleSuffix(currentUser?.LANGUAGE_ID)}`
  return {
    to_principals: usersToInform?.map(id => {
      return `user:${id}`
    }),
    data: {
      event: `${trad?.ASSIGNATION_PLAN_CONTROLE}`,
      elementInBold: controlPlan?.name,
      redirectUrl: `/controlPlans/${controlPlanId}`,
      byUser: `${currentUser.FIRSTNAME} ${currentUser.LASTNAME}`,
      infos: ``,
      email: {
        url: "https://pocketstudio.pocketresult.com/",
        event: `${currentUser.FIRSTNAME} ${currentUser.LASTNAME} ${trad?.ASSIGNATION_PLAN_CONTROLE}`,
      },
      redirect_state: {},
    },
    ephemeral: false,
    channel_id: "control_assignment" + localeSuffix,
  }
}
